<script setup>
import { stepItems } from '../../config/pageData.js';
</script>

<template>
  <section class="m-sec m-sec-dark">
    <h2 class="m-title">報名好簡單，4 步搞掂</h2>
    <div class="m-steps">
      <div
        v-for="(item, i) in stepItems"
        :key="i"
        class="m-step"
      >
        <div class="m-step-n">{{ item.n }}</div>
        <h3 class="m-step-title">{{ item.title }}</h3>
        <p class="m-step-desc">{{ item.desc }}</p>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.m-sec {
  padding: 96px 32px;
}

.m-sec-dark {
  background: #16241d;
  color: #f7f3ea;
}

.m-title {
  font-size: 44px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  color: #f7f3ea;
  letter-spacing: 1px;
}

.m-steps {
  display: grid;
  grid-template-columns: 1fr;
  gap: 28px;
  margin-top: 44px;
}

.m-step {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(201, 162, 94, 0.35);
  border-radius: 18px;
  padding: 44px 36px;
}

.m-step-n {
  font-size: 64px;
  font-weight: 700;
  color: #c9a25e;
  opacity: 0.9;
  line-height: 1;
}

.m-step-title {
  font-size: 30px;
  margin: 14px 0 10px;
  color: #fff;
  font-weight: 700;
}

.m-step-desc {
  font-size: 24px;
  color: #b9b3a2;
}
</style>
